<template>
    <div :class="{ 'is-loading': $store.state.loading.status }" :id="'page-' + $route.name">
        <navbar></navbar>

        <router-view keep-alive :key="$route.name"></router-view>

        <main-footer></main-footer>
    </div>
</template>

<script>
import Navbar from './core/Navbar.vue'
import MainFooter from './core/Footer.vue'

export default {
    components: {
        Navbar,
        MainFooter
    }
}
</script>
